import React from 'react';
import styled from 'styled-components';
import { device } from "../device";

import { IconSvg } from '../imageComponents'

const Icon = styled.div`
    display: flex;
    margin-bottom: 48px;
    @media ${device.lg} {
        margin-bottom: 64px;
    }
`;
const Image = styled.div`
    flex: 0 0 56px;
    max-width: 56px;
    margin-right: 16px;
`;
const Description = styled.div`
    align-self: center;
    flex: 1;
    
    font-size: 12px;

    color: var(--midle-gray1);
`;

const IconItem = (props) => {
    
    return (
        <Icon key={props.name}>
            <Image>
                <IconSvg iconPath={props.iconPath} fluid="presentationWidth" />
            </Image>
            <Description>{props.desc}</Description>
        </Icon>
    );
};

export default IconItem;
